module.exports = __webpack_public_path__ + "media/wordsremove.de99746a.mp4";